import React from "react";
import {Col} from "react-bootstrap";

export default function Product({product, toggleProducts}) {

    return <Col xs={6} lg={6} xl={4}>
        <div className={`item item-${product.id} ${product.selected ? '--isSelected' : ''} ${product.disabled ? '--isDisabled' : ''}`} onClick={() => toggleProducts(product)}>
            <div className="icon">
                <img src={require("../img/" + product.icon).default} alt={product.name}/>
            </div>
            <p>{product.name}</p>
        </div>
    </Col>
}
